import { useLocale } from 'next-intl';

import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const WomensHealthJumbotron = () => {
  const selectedLocale = useLocale();
  return (
    <LandingPageJumbotron
      data-cy="womens-health-jumbotron"
      description="womens_privacy_quote"
      theme="green"
      title="womens_privacy_title"
      href={`/${selectedLocale}/privacy-policy-oura-health`}
      link="womens_privacy_link"
    />
  );
};
export default WomensHealthJumbotron;
